import React from "react";
import { Helmet } from 'react-helmet';
import ArticlesList from "../components/articlesList/ArticlesList";
import styles from "./Blogs.module.css";

import translations from "../translations/blog";

const Blogs = (props) => {
  return (
    <div className={styles.page}>
      <Helmet>
        <title>{translations[props.lang].meta.title}</title>
        <meta name="description" content={translations[props.lang].meta.description}/>
        <meta property="og:title" content={translations[props.lang].meta.title}/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content={"https://www.davoyage.com/" + (props.lang==="fr"?"":props.lang+"/") + "blog/"}/>
        <meta property="og:image" content={translations[props.lang].og.image.url}/>
        <meta property="og:image:alt" content={translations[props.lang].og.image.alt}/>
        <meta property="og:description" content={translations[props.lang].meta.description}/>
        <meta property="og:site_name" content="Davoyage"/>
      </Helmet>
      <div className={styles.wrap}>
        <header className={styles.head}>
          <span className={styles.eyebrow}>{translations[props.lang].eyebrow}</span>
          <h1>{translations[props.lang].head}</h1>
          <p>{translations[props.lang].lead}</p>
        </header>
        <ArticlesList limit="0" lang={props.lang} variant="blog"/>
      </div>
    </div>
  );
};

export default Blogs;
